import { LanguagesTypes } from '@hydra/types/index';

export type UrlType = 'marketing-tools' |
  'website-reviews' |
  'keyword-tool' |
  'competitors' |
  'site-crawl' |
  'sales-tools' |
  'white-label-reports' |
  'leadgen-tool' |
  'assistant' |
  'api' |
  'sales-teams' |
  'marketing-teams' |
  'small-businesses' |
  'data-services' |
  'seo-agencies' |
  'developers' |
  'enterprise' |
  'pricing' |
  'core-web-vitals' |
  'blog' |
  'seo-guides' |
  'customer-stories' |
  'experts' |
  'extension' |
  'bulk-reports' |
  'why-woorank';

type TUrlItem = {
  urls: {[key in LanguagesTypes]: string}
};

type UrlSet = {
  [key in UrlType]: TUrlItem
};

const URL_SET: UrlSet = {
  'marketing-tools': {
    urls: {
      en: '/en/marketing-tools',
      es: '/es/herramientas-de-marketing',
      fr: '/fr/outils-marketing',
      nl: '/nl/marketing-tools',
      pt: '/pt/ferramentas-de-marketing',
      de: '/de/marketinginstrumente'
    }
  },
  'website-reviews': {
    urls: {
      en: '/en/marketing-tools/website-reviews',
      es: '/es/herramientas-de-marketing/informes-sitio-web',
      fr: '/fr/outils-marketing/rapports-sites-web',
      nl: '/nl/marketing-tools/website-reviews',
      pt: '/pt/ferramentas-de-marketing/relatorios-de-websites',
      de: '/de/marketinginstrumente/webseitenanalysen'
    }
  },
  'keyword-tool': {
    urls: {
      en: '/en/marketing-tools/keyword-tool',
      es: '/es/herramientas-de-marketing/keyword-tool',
      fr: '/fr/outils-marketing/keyword-tool',
      nl: '/nl/marketing-tools/keyword-tool',
      pt: '/pt/ferramentas-de-marketing/keyword-tool',
      de: '/de/marketinginstrumente/keyword-tool'
    }
  },
  competitors: {
    urls: {
      en: '/en/marketing-tools/competitors',
      es: '/es/herramientas-de-marketing/competidores',
      fr: '/fr/outils-marketing/concurrents',
      nl: '/nl/marketing-tools/concurrenten',
      pt: '/pt/ferramentas-de-marketing/concorrentes',
      de: '/de/marketinginstrumente/wettbewerber'
    }
  },
  'site-crawl': {
    urls: {
      en: '/en/marketing-tools/site-crawl',
      es: '/es/herramientas-de-marketing/site-crawl',
      fr: '/fr/outils-marketing/site-crawl',
      nl: '/nl/marketing-tools/site-crawl',
      pt: '/pt/ferramentas-de-marketing/site-crawl',
      de: '/de/marketinginstrumente/site-crawl'
    }
  },
  'sales-tools': {
    urls: {
      en: '/en/sales-tools',
      es: '/es/herramientas-de-ventas',
      fr: '/fr/outils-de-vente',
      nl: '/nl/sales-tools',
      pt: '/pt/ferramentas-de-vendas',
      de: '/de/verkaufsinstrumente'
    }
  },
  'white-label-reports': {
    urls: {
      en: '/en/sales-tools/white-label-reports',
      es: '/es/herramientas-de-ventas/informes-personalizables',
      fr: '/fr/outils-de-vente/rapports-marque-blanche',
      nl: '/nl/sales-tools/white-label-rapporten',
      pt: '/pt/ferramentas-de-vendas/relatorios-personalizados',
      de: '/de/verkaufsinstrumente/white-label-berichte'
    }
  },
  'leadgen-tool': {
    urls: {
      en: '/en/sales-tools/leadgen-tool',
      es: '/es/herramientas-de-ventas/leadgen-tool',
      fr: '/fr/outils-de-vente/leadgen-tool',
      nl: '/nl/sales-tools/leadgen-tool',
      pt: '/pt/ferramentas-de-vendas/leadgen-tool',
      de: '/de/verkaufsinstrumente/leadgen-tool'
    }
  },
  assistant: {
    urls: {
      en: '/en/assistant',
      es: '/es/assistant',
      fr: '/fr/assistant',
      nl: '/nl/assistant',
      pt: '/pt/assistant',
      de: '/de/assistant'
    }
  },
  api: {
    urls: {
      en: '/en/api',
      es: '/es/api',
      fr: '/fr/api',
      nl: '/nl/api',
      pt: '/pt/api',
      de: '/de/api'
    }
  },
  'sales-teams': {
    urls: {
      en: '/en/solutions/sales-teams',
      es: '/es/soluciones/equipos-de-ventas',
      fr: '/fr/solutions/equipes-de-vente',
      nl: '/nl/oplossingen/sales-teams',
      pt: '/pt/solucoes/equipes-de-vendas',
      de: '/de/loesungen/verkaufsteam'
    }
  },
  'marketing-teams': {
    urls: {
      en: '/en/solutions/marketing-teams',
      es: '/es/soluciones/equipos-de-marketing',
      fr: '/fr/solutions/equipes-marketing',
      nl: '/nl/oplossingen/marketing-teams',
      pt: '/pt/solucoes/equipes-de-marketing',
      de: '/de/loesungen/marketing-teams'
    }
  },
  'small-businesses': {
    urls: {
      en: '/en/solutions/small-businesses',
      es: '/es/soluciones/pequenas-empresas',
      fr: '/fr/solutions/pme',
      nl: '/nl/oplossingen/kmos',
      pt: '/pt/solucoes/pequenas-empresas',
      de: '/de/loesungen/kleinbetriebe'
    }
  },
  'data-services': {
    urls: {
      en: '/en/solutions/data-services',
      es: '/es/soluciones/servicios-de-datos',
      fr: '/fr/solutions/services-de-donnees',
      nl: '/nl/oplossingen/data-services',
      pt: '/pt/solucoes/servicos-de-dados',
      de: '/de/loesungen/daten-services'
    }
  },
  'seo-agencies': {
    urls: {
      en: '/en/solutions/seo-agencies',
      es: '/es/soluciones/agencias-de-seo',
      fr: '/fr/solutions/agences-seo',
      nl: '/nl/oplossingen/seo-agencies',
      pt: '/pt/solucoes/agencias-de-seo',
      de: '/de/loesungen/seo-argenturen'
    }
  },
  developers: {
    urls: {
      en: '/en/solutions/developers',
      es: '/es/soluciones/desarrolladores',
      fr: '/fr/solutions/developpeurs',
      nl: '/nl/oplossingen/ontwikkelaars',
      pt: '/pt/solucoes/desenvolvedores',
      de: '/de/loesungen/entwickler'
    }
  },
  enterprise: {
    urls: {
      en: '/en/enterprise',
      es: '/es/empresas',
      fr: '/fr/entreprise',
      nl: '/nl/grote-ondernemingen',
      pt: '/pt/empresas',
      de: '/de/unternehmen'
    }
  },
  pricing: {
    urls: {
      en: '/en/p/pricing',
      es: '/es/p/pricing',
      fr: '/fr/p/pricing',
      nl: '/nl/p/pricing',
      pt: '/pt/p/pricing',
      de: '/de/p/pricing'
    }
  },
  'core-web-vitals': {
    urls: {
      en: '/en/core-web-vitals',
      es: '/en/core-web-vitals',
      fr: '/en/core-web-vitals',
      nl: '/en/core-web-vitals',
      pt: '/en/core-web-vitals',
      de: '/en/core-web-vitals'
    }
  },
  blog: {
    urls: {
      en: '/en/blog',
      es: '/es/blog',
      fr: '/fr/blog',
      nl: '/nl/blog',
      pt: '/pt/blog',
      de: '/de/blog'
    }
  },
  'seo-guides': {
    urls: {
      en: '/en/edu/seo-guides',
      es: '/es/edu/seo-guides',
      fr: '/fr/edu/seo-guides',
      nl: '/nl/edu/seo-guides',
      pt: '/pt/edu/seo-guides',
      de: '/de/edu/seo-guides'
    }
  },
  'customer-stories': {
    urls: {
      en: '/en/customer-stories',
      es: '/en/customer-stories',
      fr: '/en/customer-stories',
      nl: '/en/customer-stories',
      pt: '/en/customer-stories',
      de: '/en/customer-stories'
    }
  },
  experts: {
    urls: {
      en: 'https://experts.woorank.com/en/experts',
      es: 'https://experts.woorank.com/es/experts',
      fr: 'https://experts.woorank.com/fr/experts',
      nl: 'https://experts.woorank.com/en/experts',
      pt: 'https://experts.woorank.com/pt/experts',
      de: 'https://experts.woorank.com/en/experts'
    }
  },
  extension: {
    urls: {
      en: '/en/extension',
      es: '/es/extension',
      fr: '/fr/extension',
      nl: '/nl/extensie',
      pt: '/pt/extensao',
      de: '/de/erweiterungen'
    }
  },
  'bulk-reports': {
    urls: {
      en: '/en/bulk-reports',
      es: '/es/informes-en-lote',
      fr: '/fr/analyses-groupees',
      nl: '/nl/bulk-rapportage',
      pt: '/pt/relatorios-em-massa',
      de: '/de/multiple-berichterstellung'
    }
  },
  'why-woorank': {
    urls: {
      en: '/en/why-woorank',
      es: '/es/por-que-woorank',
      fr: '/fr/pourquoi-woorank',
      nl: '/nl/waarom-woorank',
      pt: '/pt/por-que-woorank',
      de: '/de/warum-woorank'
    }
  }
};

export default function getTranslatedUrl (source: UrlType, lang: LanguagesTypes) {
  return URL_SET[source]?.urls[lang];
}
